import { userService } from '@/api/user.service';
import router from '@/router/index';

export const state =
{
  status: { loggingIn: false, loggedIn: false, requiresOtp: false },
  user: {
    firstName: "",
    lastName: "",
    confirmedAt: "",
    createdAt: "",
    phoneNumber: "",
    company: "",
    email: "",
    role: "",
    rules: []
  },
}

export const getters = {
  loggedIn(state) {
    return state.status.loggedIn
  },
  requiresOtp(state) {
    return state.status.requiresOtp;
  },
}

export const actions = {
  // Logs in the user.
  logIn({ dispatch, commit, rootState }, user) {
    commit('loginRequest');

    userService.login(user)
      .then(
        ({ data, message }) => {
          if (data.requiresOtp) {
            commit('otpRequired');
          } 
          else {
            commit('setRules', data.rules, { root: true });
            commit('authSuccess', data, commit);
            dispatch('notification/success', message, { root: true });
            dispatch('property/getProperties', { resetCache: true,  
              callback: ()=>{
                const properties = rootState.property.properties;
                if (properties.length > 0) router.push(`/properties/${properties[0].id}`);
                else router.push("/profile");
              }
            },
            { root: true }
            )
          }
        },
        ({ error }) => {
          commit('authFailure');
          dispatch('notification/error', error, { root: true });
        }
      );
  },

  sendOtp({ dispatch }) {
    return userService.sendOtp()
      .then(
        response => {
          dispatch('notification/success', 'OTP sent successfully', { root: true });
          return response;
        },
        ({ error }) => {
          dispatch('notification/error', error, { root: true });
        }
      );
  },
  verifyOtp({ dispatch, commit, rootState }, otp) {
  return userService.verifyOtp(otp)
    .then(
      ({ data, message }) => {
        commit('otpVerified');
        console.log('OTP verification success:', data);
        console.log("Message: ", message);

        commit('setRules', data.rules, { root: true });
        commit('authSuccess', data);
        dispatch('notification/success', message, { root: true });
        dispatch('property/getProperties', { resetCache: true,
              callback: ()=>{
                const properties = rootState.property.properties;
                if (properties.length > 0) router.push(`/properties/${properties[0].id}`);
                else router.push("/profile");
              }
            },
            { root: true }
          );
      },
      ({error}) => {
        console.log('OTP verification error:', error);

        dispatch('notification/error', error, { root: true });
      }
    );
  },
  // Logout the user
  logOut({ commit, dispatch }) {
    userService.logout();
    commit('setRules', null, {root: true});
    commit('logout');
    router.push('/login');
    dispatch("property/clearProperties", null, { root: true });
  },
  forgotPassword({ dispatch },  email){
    userService.forgotPassword(email)
      .then(
        () => {
          const message = 'Your password reset request has been received. Please check your inbox.';
          dispatch('notification/success', message, { root: true })
        },
        ({ errors: { email } }) => {
          dispatch('notification/error', `Email ${email[0]}`, { root: true });
        }
      );
  },
  setPassword({ commit, dispatch },  payload){
    userService.setPassword(payload)
      .then(
        () => {
          router.push('/login');
          dispatch('notification/success', 'Password changed', { root: true });
        },
        ({ errors: { password, password_confirmation, reset_password_token} }) => {
          let message;

          if (password) message = `Password ${password[0]}`;
          else if (password_confirmation) message = `Password Confirmation ${password_confirmation[0]}`;
          else message = `Token ${reset_password_token[0]}`;

          commit('passwordFailure');
          dispatch('notification/error', message, { root: true });
        }
      );
  },
  updateUser({ commit, dispatch }, user) {
   userService.updateUser(user)
    .then(
      ({ data, message }) => {
        commit('updateSuccess', data);
        dispatch('notification/success', message, { root: true });
      },
      ({ message }) => {
        dispatch('notification/error', message, { root: true });
      }
    );
  }
};

export const mutations = {
  loginRequest(state) {
    state.status = { loggingIn: true };
  },
  authSuccess(state, data) {
    state.status = { loggedIn: true, requiresOtp: false};
    let userData = {
      confirmedAt : data.confirmed_at,
      createdAt : data.created_at,
      firstName : data.first_name,
      lastName : data.last_name,
      phoneNumber: data.phone_number,
      company: data.company,
      email: data.email,
      role: data.role
    }
    state.user = userData;
    state.rules = [...data.rules];
  },
   otpRequired(state) {
    state.status = { loggingIn: false, requiresOtp: true };
  },
  otpVerified(state) {
    state.status = { loggedIn: true, requiresOtp: false };
  },
  authFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  passwordFailure(state) {
    state.status = {};
  },
  updateSuccess(state, data) {
    state.user.firstName = data.first_name;
    state.user.lastName = data.last_name;
    state.user.phoneNumber = data.phone_number;
  }
};
